export const Bio = {
    name: " Venkata Naveen V",
    roles: [
      "Full Stack Developer",
      "Software Engineer",
      "Software Developer",
      "Backend Developer",
      "API Developer"
    ],
    description: "I am a motivated and versatile developer, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/naveen-v-v",
    // resume: "https://docs.google.com/document/d/18K4O_4mPyj2-6XjAIFpAho6Nkwpx5rvu8MFctfJ6JAM/edit?usp=sharing",
    linkedin: "https://www.linkedin.com/in/naveen-v-v/",
    medium: "https://medium.com/@naveen-v-v",
  };
  
export const skills = [
    {
        title: "Backend",
        skills: [
          {
            name: "Spring Boot",
            image: "https://img.shields.io/badge/Spring%20Boot-6DB33F?logo=springboot&logoColor=fff&style=for-the-badge",
          },
          {
            name: "Apache Kafka",
            image: "https://www.vectorlogo.zone/logos/apache_kafka/apache_kafka-icon.svg",
          },
          {
            name: "Node Js",
            image: "https://nodejs.org/static/images/logo.svg",
          },
          {
            name: "Express Js",
            image:"https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/express/express-original.svg",
          },
          {
            name: "Redis",
            image:
              "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redis/redis-original.svg",
          },
          {
            name: "Nest Js",
            image:
              "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nestjs/nestjs-original.svg",
          },
          {
            name: "TypeScript",
            image:
            "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg"
          },
          {
            name: "Python",
            image:
              "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
          },
          {
            name: "Flask",
            image:
              "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3c/Flask_logo.svg/1280px-Flask_logo.svg.png",
          },
          {
            name: "Django",
            image:
              "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSlFFyY16N5NRhzoG24RqB7x8Ok2t8Bdgs-tuMsOBXS2Q&s",
          },
          {
            name: "Oauth",
            image:
            "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/google/google-original.svg"
          }
        ],
    },
    {
      title: "Database",
      skills: [
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
        {
          name: "Postgresql",
          image: "https://www.postgresql.org/media/img/about/press/elephant.png",
        },
        {
          name: "MongoDB",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
        },
        {
          name: "Spring JPA",
          image: "https://spring.io/img/projects/spring-data.svg",
        },
        {
          name: "Hibernate",
          image: "https://img.shields.io/badge/Hibernate-59666C?logo=hibernate&logoColor=fff&style=for-the-badge",
        },
        {
          name: "Firebase",
          image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
        },
      ],
    },
    {
      title: "Amazon Web Services (AWS)",
      skills: [
        {
          name: "Lambda",
          image:
            "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
        },
        {
          name: "S3",
          image:
            "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
        },
        {
          name: "DynamoDB",
          image:
            "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
        },
        {
          name: "API Gateway",
          image:
            "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
        },
        {
          name: "CloudFormation",
          image:
            "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
        },
        {
          name: "CloudWatch",
          image:
            "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
        },
        {
          name: "SNS(Simple Notification Service)",
          image:
            "https://download.logo.wine/logo/Amazon_Web_Services/Amazon_Web_Services-Logo.wine.png",
        }
      ],
    },
    {
        title: "Frontend",
        skills: [
            {
            name: "ReactJs",
            image:
                "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
            },
            {
              name: "Angular",
              image:
                  "https://img.icons8.com/?size=96&id=71257&format=png",
              },
            {
            name: "Redux",
            image:
                "https://d33wubrfki0l68.cloudfront.net/0834d0215db51e91525a25acf97433051f280f2f/c30f5/img/redux.svg",
            },
            {
            name: "HTML",
            image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
            },
            {
            name: "CSS",
            image:
                "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
            },
            {
            name: "JavaScript",
            image:
                "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
            },
            {
            name: "Bootstrap",
            image:
                "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
            }
        ],
    },
    {
      title: "Machine Learning",
      skills: [
        {
          name: "Python",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/python/python-original.svg",
        },
        {
          name: "Tenserflow",
          image:
            "https://www.vectorlogo.zone/logos/tensorflow/tensorflow-icon.svg",
        },
        {
          name: "Keras",
          image:
            "https://miro.medium.com/v2/resize:fit:600/1*DKu_54iqz6C-p6ndo7rO3g.png",
        },
        {
          name: "Jupyter",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/3/38/Jupyter_logo.svg/1767px-Jupyter_logo.svg.png",
        },
        {
          name: "Google Colab",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/Google_Colaboratory_SVG_Logo.svg/1200px-Google_Colaboratory_SVG_Logo.svg.png",
        },
        {
          name: "Sk Learn Kit",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Scikit_learn_logo_small.svg/2560px-Scikit_learn_logo_small.svg.png",
        },
      ],
    },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://e7.pngegg.com/pngimages/713/558/png-clipart-computer-icons-pro-git-github-logo-text-logo-thumbnail.png",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "Netlify",
          image:
            "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
        },
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
        {
          name: "Postman",
          image:
            "https://www.vectorlogo.zone/logos/getpostman/getpostman-icon.svg",
        },
        // {
        //   name: "Google Cloud",
        //   image:
        //     "https://static-00.iconduck.com/assets.00/google-cloud-platform-logo-icon-2048x1824-pg4wzspq.png",
        // },
        {
          name: "Docker",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
        },
        // {
        //   name: "Jenkins",
        //   image:
        //     "https://toppng.com/uploads/preview/jenkins-logo-11609365847mufysaivph.png",
        // }
        {
          name: "Kubernetes",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/0/00/Kubernetes_%28container_engine%29.png",
        },
        {
            name: "Heroku",
            image:
              "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/heroku/heroku-plain.svg",
        }
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: "https://media.licdn.com/dms/image/v2/D4E0BAQH3oj32srZDhw/company-logo_100_100/company-logo_100_100/0/1719926592217/cibc_logo?e=1745452800&v=beta&t=ZOCcMN2UeVQIgEMiGFOJEGVbYQZCKs5esWpESyH1QJc",
      role: "Full Stack Developer",
      company: "CIBC",
      date: "October 2022 - Present",
      // desc: "I develop scalable back-end systems using Node.js and design patterns while integrating real-time features with MongoDB, React.js, and TypeScript. I improve platform performance by 20% through effective caching and optimization techniques. I implement secure user authentication using JWT and bcrypt, ensuring robust data protection. I create responsive and reusable UI components with React.js, enhancing user experience. I ensure application reliability and quality through rigorous testing using Jest, Supertest, and Postman.",
      skills: [
        "Spring Boot", "Node", "React", "Angular", "Java", "MySQL", "MongoDB"
      ],
    //   doc: "",
    },
    {
      id: 1,
      img: "https://github.com/naveen-v-v/naveen-v-v.github.io/blob/main/public/assets/acko-logo.png?raw=true",
      role: "Software Engineer",
      company: "Acko General Insurance",
      date: "Sep 2021 - Sep 2022",
      // desc: "Spearheaded revolutionary development initiatives by leveraging AWS cloud lambdas powered by Node.js, and crafting intuitive UIs with React, facilitating seamless integration with IoT devices, APIs, and User Interfaces, thereby elevating overall application functionality. Fostered collaborative synergy within a dynamic six-person team, enhancing project cohesion and driving efficient project execution. Streamlined coding processes through adept utilization of Amazon Web Services tools including AWS CloudWatch, S3 buckets, and the boto3 library, resulting in optimized development workflows. Proficiently administered MySQL databases within an Agile SCRUM environment, ensuring smooth project progression while utilizing JIRA and Bitbucket for streamlined project management and version-controlled code sharing.",
      skills: [
        "NodeJs",
        "MySQL database",
        "ReactJS",
        "Typescript",
        "HTML",
        "CSS",
        "JavaScript",
        "AWS",
        "S3 Bucket",
        "AWS Lambda",
        "AWS API Gateway"
      ],
    //   doc: "",
    },
    {
      id: 2,
      img: "https://media.licdn.com/dms/image/v2/D4D0BAQGlmfDGwVxhhA/company-logo_100_100/company-logo_100_100/0/1691492864169/valuelabs_logo?e=1745452800&v=beta&t=7RV2LZd4ute4eLjFnVizL1rbEDj6kv2nJ2pg-7IPbCE",
      role: "Software Developer",
      company: "ValueLabs",
      date: "August 2019 - Sep 2021",
      // desc: "I developed a full-featured e-commerce website using the MERN stack, integrating product reviews, ratings, search, and secure authentication with JWT. I managed a scalable MongoDB Atlas database and built dynamic user profiles for order management, along with admin access for managing products, users, and orders. The platform supports PayPal and credit card payments, features a shopping cart, product pagination, and order status updates. I also created an admin dashboard for easy management and used Redux for state management, ensuring a responsive UI. Database seeders were implemented to streamline development and testing.",
      skills: [
        "NodeJs",
        "MongoDB database",
        "ReactJS",
        "Redux",
        "Typescript",
        "HTML",
        "CSS",
        "JavaScript"
      ],
    //   doc: "",
    }
  ];
  
  export const education = [
    // {
    //   id: 0,
    //   img: "https://github.com/naveen-v-v/naveen-v-v.github.io/blob/main/public/assets/uwindsor_logo.jpeg?raw=true",
    //   school: "University of Windsor",
    //   date: "Sep 2022 - Dec 2023",
    //   grade: "8.7 CGPA",
    //   degree: "Master of Applied Computing - MAC, Computer Science",
    // },
    {
      id: 0,
      img: "https://github.com/naveen-v-v/naveen-v-v.github.io/blob/main/public/assets/andhra_university.jpeg?raw=true",
      school: "Andhra University",
      date: "",
      grade: "8.2 CGPA",
      degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
    }
  ];
  
  export const projects = [
    {
      id: 0,
      title: "Patient Management System (In progress...)",
      date: "",
      description:
        "A web app application used to manage patients built using Springboot, Kafka, Postgres, REST and gRPC API",
      image:
        "https://github.com/naveen-v-v/patient-management-system/blob/main/architectures/kafka-architecture.png?raw=true",
      tags: [
        "Java",
        "Spring Boot",
        "Kafka",
        "PostgreSQL",
        "REST API",
        "gRPC API",
        "Docker"
      ],
      category: "web app",
      github: "https://github.com/naveen-v-v/patient-management-system",
      webapp: "https://github.com/naveen-v-v/patient-management-system"
    },
    {
      id: 1,
      title: "Foodie-Frenzy",
      date: "",
      description:
        "A food delivery web application named 'foodie-frenzy', tech stack is MERN (MongoDB, Express, Reactjs, Nodejs). Deployed on Render (A website hosting platform). Features include user authentication, login, new user creation, admin features of a food ordering service, food items, payment process using Stripe.",
      image:
        "https://github.com/user-attachments/assets/b1ab13e9-7970-4fe6-b8ce-a077e257d80f",
      tags: [
        "Node Js",
        "MongoDB",
        "Express Js",
        "React Js",
        "Jest"
      ],
      category: "web app",
      github: "https://github.com/naveen-v-v/foodie-frenzy",
      webapp: "https://foodie-frenzy-frontend.onrender.com"
    },
    {
      id: 2,
      title: "ShopPro",
      date: "",
      description:
        "A Full Stack Ecommerce website called 'ShopPro', using MongoDB, Express, ReactJS, NodeJS (MERN) packed with essential features for a seamless shopping experience. From the fully functional shopping cart to interactive product reviews and a user-friendly top products carousel, every aspect has been carefully crafted. Customers can easily navigate through products with smooth pagination and a handy search feature, while personalized user profiles keep track of their orders. Behind the scenes, I've developed intuitive admin tools for efficient product, user, and order management. With integrated PayPal and credit card payment options and automated database seeding, I've ensured a hassle-free shopping experience from start to finish.",
      image:
        "https://github.com/naveen-v-v/naveen-v-v.github.io/blob/main/public/assets/shoppro.png?raw=true",
      tags: [
        "Node Js",
        "MongoDB",
        "Express Js",
        "React Js",
        "Redux",
        "PayPal Payments"
      ],
      category: "web app",
      github: "https://github.com/naveen-v-v/ecommerce-website",
      webapp: "https://shoppro-qtmo.onrender.com"
    },
    {
      id: 3,
      title: "Social Media Posts",
      date: "",
      description:
        "I created a dynamic social media platform using the MERN stack, enabling users to share their life events. With full CRUD functionality, users can post, edit, and delete content seamlessly. The application boasts a sleek interface built with React, supported by a robust backend powered by Express and Node.js. It facilitates user engagement with features like commenting and liking posts.",
      image:
        "https://github.com/naveen-v-v/naveen-v-v.github.io/blob/main/public/assets/socialposts.png?raw=true",
      tags: [
        "Node Js",
        "MongoDB",
        "Express Js",
        "React Js",
        "Netlify"
      ],
      category: "web app",
      github: "https://github.com/naveen-v-v/social_posts_application",
      webapp: "https://playful-kheer-3ff695.netlify.app"
    },
    {
      id: 4,
      title: "Chat application",
      date: "",
      description:
        "A Chat room application, where users can join the room and share messages and location, making use of web sockets and some other npm modules of nodejs",
      image:
        "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*M9sRHsJKHMNqcFnuEN-Viw.png",
      tags: [
        "Node.js",
        "Socket.io",
        "Geographic location",
        "Express.js",
        "bad-word library"
      ],
      category: "web app",
      github: "https://github.com/naveen-v-v/chat-application",
      medium: "https://naveen-v-v.medium.com/chat-application-using-sockets-nodejs-e7e94277c57c"
    },
    {
      id: 5,
      title: "Task Manager Application",
      date: "",
      description:
        "A Task-manager-app using MongoDb, performing REST API Operations like GET/POST/PATCH/DELETE to play around with the data in MongoDb Database(by performing CRUD Operations) using Nodejs, Express FrameWork.",
      image:
        "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*w16Wc77FoVVw9hqz.png",
      tags: [
        "Node.js",
        "MongoDB",
        "CRUD Operations",
        "Express.js"
      ],
      category: "web app",
      github: "https://github.com/naveen-v-v/task-manager-app/",
      postman: "https://documenter.getpostman.com/view/15945431/TzXwEdb9"
    },
    {
      id: 6,
      title: "Real Time Weather App, using NodeJs and external Weather API’s",
      date: "",
      description:
        "A web app that gets the Weather data bsed on users location, using external Weather API’s like WeatherStack API (for weather data), Mapbox API(for longitude, latitude), node and express.",
      image:
        "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*x_Xof4pATjCCQpBV7BSOYQ.png",
      tags: [
        "Node.js",
        "WeatherStack API",
        "MapBox API",
        "Express.js"
      ],
      category: "web app",
      github: "https://github.com/naveen-v-v/weather_website",
      webapp: "https://weather-website-xujq.onrender.com"
    },
    {
      id: 7,
      title: "User Management System",
      date: "",
      description:
        "A user management system using Node.js, Express, Express-Handlebars and MySQL",
      image:
        "https://i.ytimg.com/vi/VaUsQ9kb1WI/maxresdefault.jpg",
      tags: [
        "Node.js",
        "MySQL",
        "Handlebars",
        "Express.js"
      ],
      category: "web app",
      github: "https://github.com/naveen-v-v/user-management-site",
      medium: "https://naveen-v-v.medium.com/user-management-system-nodejs-express-mysql-handlebards-15cf7131d367"
    },
    {
      id: 8,
      title: "Heart Disease Risk Prediction using Supervised Machine Learning",
      date: "",
      description:
        "Implementing coronary heart disease prediction model with a dataset by performing several operations like preprocessing data, exploratory analysis, feature selection, SMOTE, Training the model using Machine Learning algorithms namely Logistic Regression, Decision Tree, K-Nearest Neighbor, Support Vector Machine, Testing the model and selecting the best model among them.",
      image:
        "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*JJZb9g8Fc2mYnOFW.png",
      tags: [
        "Python",
        "Machine Learning",
        "Jupyter Notebook",
        "Data Preprocessing",
        "Data Visualization",
        "Decision Tree",
        "K-Nearest Neighbor",
        "ML Model Selection",
        "SMOTE"
      ],
      category: "ML",
      github: "https://github.com/naveen-v-v/heart-disease-risk-prediction-using-supervised-machine-learning",
      medium: "https://naveen-v-v.medium.com/heart-disease-risk-prediction-using-supervised-machine-learning-baaece3649a"
    },
    {
      id: 9,
      title: "Hand Written Digit Recognition using Deep Neural Networks",
      date: "",
      description:
        "A program to identify handwritten digits from 0 to 9 using basic deep neural networks. We will discuss how to implement this model. Tools used Python, Jupyter Notebook, Keras , Tensorflow, MNIST dataset.",
      image:
        "https://miro.medium.com/v2/resize:fit:530/format:webp/1*8yAyYB5yy3Zb5DLlOrRFhw.png",
      tags: [
        "Python",
        "Deep Nueral Networks",
        "Jupyter Notebook",
        "Data Preprocessing",
        "Data Visualization",
        "Keras",
        "Tensorflow"
      ],
      category: "ML",
      github: "https://github.com/naveen-v-v/hand-written-digit-recognition",
      medium: "https://naveen-v-v.medium.com/hand-written-digit-recognition-using-deep-neural-networks-with-mnist-dataset-p-4-635bf20cb5e1"
    },
  ];

  export const articles = [
    {
      id: 0,
      title: "Containerizing using Docker",
      date: "November 2024",
      description:
        "How to containerize an application and create a Docker Compose file for running multiple container along with the networking.",
      image:"https://miro.medium.com/v2/resize:fit:1400/format:webp/0*m4Easurr6gXUgykC.png",
      tags: [
        "Docker",
        "Docker-Compose",
        "Containerization",
        "DockerFile"  
      ],
      medium: "https://medium.com/@naveen-v-v/containerizing-an-application-and-deploying-using-docker-compose-5e8bb93b2e86"
    },
    {
      id: 1,
      title: "Hosting an app on AWS EC2: A Simple Guide",
      date: "April 2024",
      description:
        "In this blog post, we’ll walk you through the step-by-step process of deploying your web application to Amazon Web Services (AWS) Elastic Compute Cloud (EC2).",
      image:"https://miro.medium.com/v2/resize:fit:1400/format:webp/0*Siu16y5l7TMWplCv.jpeg",
      tags: [
        "AWS",
        "EC2 instance",
        "Nodejs",
        "Linux",
        "Ubuntu",
        "Systemd"
      ],
      medium: "https://medium.com/@naveen-v-v/hosting-an-app-on-aws-ec2-a-simple-guide-52a01c61a226"
    },
    {
      id: 2,
      title: "Database Sharding and Multiple Databases Architecture implementation",
      date: "January 2024",
      description:
        "In this article, we dive into the intricacies of Database Sharding and Multiple DB approaches, exploring their benefits, challenges, and how they can be effectively implemented using NodeJS to unlock the potential of data management systems.",
      image:"https://miro.medium.com/v2/resize:fit:1400/format:webp/0*3v5RsmbTIoNPuwRD.png",
      tags: [
        "Database",
        "Sharding",
        "Virtical Partitions",
        "Horizontal Partitions",
        "Key-Based Sharding",
        "Range-Based Sharding"
      ],
      medium: "https://medium.com/@naveen-v-v/database-sharding-and-multiple-databases-architecture-implementation-a6ee409c0e47"
    },
    {
      id: 3,
      title: "Secure User Authentication: A Guide to Sending mobile OTPs via Twilio and Node.js",
      date: "December 2023",
      description: "In this article, we explore the power of Twilio and Node.js in seamlessly integrating one-time passwords (OTPs) for mobile authentication. Twilio is an online platform for communication. We may send text messages via SMS, WhatsApp, and email, record voice messages, initiate calls, and initiate chats directly from our application with the Twilio services.",
      image: "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*Y_RFNgvc0_QThNYt.jpg",
      tags: ["Nodejs", "Twilio", "OTP", "User authentication"],
      medium: "https://naveen-v-v.medium.com/secure-user-authentication-a-guide-to-sending-mobile-otps-via-twilio-and-node-js-c613df1e3e20"
    },
    {
      id: 4,
      title: "Large Language Models (LLMs): A Dive into Fine Tuning with Practical Examples",
      date: "December 2023",
      description: "In this article, we’ll explore the process of fine-tuning a pre-trained LLM. We’ll begin by introducing essential concepts and techniques for fine-tuning and conclude with a specific example demonstrating how to fine-tune a model locally using Python and Hugging Face’s software ecosystem.",
      image: "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*ETZxsbEn1ZOtBNEt.png",
      tags: ["LLM", "Python", "Fine-tune", "Machine Learning", "LoRA"],
      medium: "https://naveen-v-v.medium.com/large-language-models-llms-a-dive-into-fine-tuning-with-practical-examples-1fdbcee00c6f"
    },
    {
      id: 5,
      title: "Caching Concepts in NodeJS with examples",
      date: "November 2023",
      description: "We go through implementation types of caching(In-Memeory and Redis caching) and how to implement them using NodeJS with practical examples.",
      image: "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*mu6yVOdpdy5GNTUq",
      tags: ["Redis", "Cache", "In-Memory Cache", "Nodejs", "Expressjs", "postman"],
      medium: "https://naveen-v-v.medium.com/caching-concepts-in-nodejs-with-examples-a5afeb62fcb9"
    },
    {
      id: 6,
      title: "Google Login (Authentication using Oauth2, Passport, NodeJS)",
      date: "November 2023",
      description: "We go through how to login/authenticate users using there google account with the help of passport, Oauth2.",
      image: "https://miro.medium.com/v2/resize:fit:1400/format:webp/0*qX6f-X7LzdXzQR40.jpeg",
      tags: ["Oauth2", "passport", "Nodejs", "Expressjs", "User authentication"],
      medium: "https://naveen-v-v.medium.com/google-login-authentication-using-oauth2-passport-nodejs-214bcf0a0bdb"
    },
    {
      id: 7,
      title: "Chatbot with OpenAI API and NodeJS",
      description: "We’ll use the ChatGPT API with Node.js to build a versatile chatbot powered by the GPT-3.5 Turbo model. This bot, operating in your terminal, covers a wide range — answering questions, generating code and more. It’s essentially ChatGPT tailored for your application using a Node.js wrapper. This setup provides a handy way to chat directly in your terminal, and it can serve as a base for your own chatbot.",
      date: "November 2023",
      image: "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*LAPUQLHwM9Ab9cIUNIrLmw.png",
      tags: ["OpenAI", "ChatGPT API", "Nodejs"],
      medium: "https://naveen-v-v.medium.com/chatbot-with-openai-api-and-nodejs-7e1efc871604"
    },
    {
      id: 8,
      title: "Increase Speed of the Nodejs Server using Compression (Gzip)",
      date: "December 2022",
      description: "Based on the fact that “Transferring a data of less size is faster when compared to that of a data with more size”, if we reduce the size of the document coming from the server our applications we can make our application faster.",
      image: "https://miro.medium.com/v2/resize:fit:1400/format:webp/1*1D2rod-tMub4w8ORoTQXeQ.png",
      tags: ["Gzip", "compress", "Nodejs", "Server", "runtime", "weather app"],
      medium: "https://medium.com/@naveen-v-v/increase-speed-of-the-nodejs-server-using-compression-gzip-5b18e4194127"
    }
  ];
